/**
 * Safe template interpolation for translation strings.
 *
 * Replaces all `{placeholder}` tokens in `template` with the matching value
 * from `vars`.  Uses split/join rather than String.replace() to avoid
 * JavaScript's RegExp-style replacement patterns (`$&`, `$1`, etc.) from
 * appearing in untrusted variable values (player names, tab labels, etc.).
 *
 * Also replaces ALL occurrences of each placeholder, unlike
 * `string.replace(literal, value)` which only replaces the first.
 *
 * Usage:
 *   tFormat(t.play_other_turn, { name: currentTurnPlayer })
 *   // "⏳ Alice's turn"
 *
 * See: i18n-audit-2026-04 Medium finding #17 — placeholder interpolation.
 */
export function tFormat(template: string, vars: Record<string, string>): string {
  return Object.entries(vars).reduce(
    (s, [key, val]) => s.split(`{${key}}`).join(val),
    template,
  );
}
